export const HARDINESS_ZONES = Array.from(
    {length: 26},
    (_, index) => `${Math.floor(index / 2) + 1}${index % 2 === 0 ? 'a' : 'b'}`
);

export function getInitialRegistrationCountry(market) {
    return market === 'US' ? 'us' : undefined;
}

export function parseRegistrationPlanId(value) {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (!/^[1-9]\d*$/.test(value)) {
        throw new Error('Invalid plan_id');
    }
    const planId = Number(value);
    if (!Number.isSafeInteger(planId)) {
        throw new Error('Invalid plan_id');
    }
    return planId;
}

export function getRegistrationMarketProfile(country, selectedLanguage = 'en') {
    if ((country || '').toLowerCase() === 'us') {
        return {
            market: 'US',
            language: 'en',
            measurements: 'imperial',
            requiresHardinessZone: true,
        };
    }

    return {
        market: 'EU',
        language: selectedLanguage,
        measurements: 'metric',
        requiresHardinessZone: false,
    };
}
